import bellIcon from '@iconify/icons-heroicons-outline/bell';
import React, { forwardRef } from 'react';

import MemoizedIcon from '@components/MemoizedIcon';
import { useNotificationContext } from '@src/context/NotificationContext';

interface TriggerProps {
  getReferenceProps?: (
    userProps?: React.HTMLProps<Element> | undefined,
  ) => Record<string, unknown>;
}
const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ getReferenceProps }, ref) => {
    const { unread } = useNotificationContext();

    return (
      <button
        ref={ref}
        data-testid="notification-container"
        className="relative w-fit h-fit"
        type="button"
        {...getReferenceProps?.()}
      >
        <MemoizedIcon icon={bellIcon} className="h-6 w-6" />
        {!!unread && (
          <p
            data-testid="notification-count-badge"
            className="flex items-center text-xs font-semibold text-white justify-center bg-danger-500 rounded-[11px] h-[22px] min-w-[22px] w-fit absolute -top-[7px] left-[8px] border border-white px-[7px]"
          >
            {unread > 9 ? '+9' : unread}
          </p>
        )}
      </button>
    );
  },
);

export default Trigger;
